import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MainVueOpts } from '../../../main-vue';
import { createUpdateApplicationService, goToFirstError } from '../../../helper-functions/services';
import { createDateByLangApplications } from '../../../helper-functions/helper-functions';
import Step1Mixin from '../mixins/Step1Mixin';

Vue.use(Vuelidate);

export default {
    mixins:[MainVueOpts, Step1Mixin],
    components:{
    },
    props:['form-data'],
    data: function() {
        return {
            form: {
                careingtonBillingOpt: ibJS.application?.careingtonBillingOpt || '',
                careingtonNumMonths: ibJS.application?.careingtonNumMonths || '',
                noOfMembers: ibJS.application?.travelerInfos?.length || ''
            },
            startDates: window.ibJS.careingtonStartDates || null,
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,
            formSending: false
        }
    },
    validations: function(){
        var validations = {
            form:{
                careingtonBillingOpt: {
                    required
                },
                startDate: {
                    required
                },
                careingtonNumMonths: {},
                noOfMembers: {
                    required
                }
            }
        };

        if(this.form.careingtonBillingOpt == '1') {
            validations.form.careingtonNumMonths.required = required;
        } else {
            delete validations.form.careingtonNumMonths.required;
        }

        return validations;
    },
    mounted () {
        if(this.startDates && Array.isArray(this.startDates) && this.startDates.indexOf(this.form.startDate) < 0) {
            this.form.startDate = '';
        }
    },
    computed: {
        disableContinue() {
            return this.$v.form.$error && this.$v.form.$invalid;
        },
        showActionButtonError() {
            return this.$v.form.$error && this.$v.form.$invalid;
        }
    },
    watch:{
        'form.careingtonBillingOpt': function(val) {
            if(val == '1') {
                this.form.careingtonNumMonths = '';
            }
        }
    },
    methods: {
        createQuote: function (e) {
            e.preventDefault();
            this.$v.$touch();

            this.form.travelerInfos = [];
            let numOfTraveler = this.form.noOfMembers;
            while(numOfTraveler > 0) {
                var newTraveler = {
                    age: '-1',
                    tripCost: null,
                    quotePrice: null,
                    travelerType: ''
                };
                this.form.travelerInfos.push(newTraveler);
                numOfTraveler--;
            }

            var quoteResultsURL='/api/'+ibJS.productName+'/quote-results/?lang='+window.globalLanguage.lang;

            if (!this.$v.$invalid) {
                Vue.nextTick(() => {
                    let langBasedData = Object.assign({}, this.form);
                    createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                    createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application');
                });
            } else{
                Vue.nextTick(() => goToFirstError());
            }
        }
    }
};
